import React, { createContext, useContext, useEffect, useState } from "react";
const AssetMaintenanceContext = createContext({});

export const AssetMaintenanceProvider = ({ children }) => {
    const [valueSearchAssetMaintenance, setValueSearchAssetMaintenance] = useState(null)
    useEffect(() => {
    }, [])
    return (
        <AssetMaintenanceContext.Provider
            value={{
                valueSearchAssetMaintenance, setValueSearchAssetMaintenance
            }}
        >
            {children}
        </AssetMaintenanceContext.Provider>
    );
};

export default function useAssetMaintenance() {
    const context = useContext(AssetMaintenanceContext);
    return context;
}
